import { Splide } from '../main.js';

const splideFrameCarouselEl = document.querySelectorAll('.js-splide-frame-carousel');

if (splideFrameCarouselEl.length > 0) {
    Array.from(splideFrameCarouselEl).forEach((carousel) => {
        const splideFrameCarousel = new Splide(carousel, {
            rewind: true,
            perPage: 4,
            perMove: 1,
            type: 'loop',
            gap: 32,
            speed: 700,
            drag: true,
            pagination: false,
            arrows: false,
            trimSpace: 'move',

            breakpoints: {
                1440: {
                    perPage: 3,
                    padding: '0rem',
                    gap: 24,
                    omitEnd: false,
                    focus: false,
                },

                1024: {
                    perPage: 2,
                    padding: '4rem',
                    gap: 24,
                    omitEnd: true,
                    focus: 'center',
                },

                640: {
                    perPage: 1,
                    padding: '6rem',
                    gap: 32,
                    omitEnd: true,
                    focus: 'center',
                },
            },
        });

        splideFrameCarousel.mount();
    });
}
